import { createSlice } from "@reduxjs/toolkit";
import { apiGetWhatWeDo, apiGetWhatWeDoDetails } from "../helpers/backend_helper";

const whatWeDoSlice = createSlice({
  name: "whatWeDo",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    fetchWhatWeDoRequest(state) {
      state.loading = true;
      state.error = null;
    },
    fetchWhatWeDoSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    fetchWhatWeDoFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchWhatWeDoRequest, fetchWhatWeDoSuccess, fetchWhatWeDoFailure } = whatWeDoSlice.actions;

export const fetchWhatWeDoData = () => async (dispatch) => {
  dispatch(fetchWhatWeDoRequest());
  try {
    const response = await apiGetWhatWeDo(); 
    dispatch(fetchWhatWeDoSuccess(response.results.data)); 
  } catch (error) {
    dispatch(fetchWhatWeDoFailure(error.message || "Failed to fetch what we do data."));
  }
};

export const fetchWhatWeDoDetailsData = (id) => async (dispatch) => {
  dispatch(fetchWhatWeDoRequest());
  try {
    const response = await apiGetWhatWeDoDetails(id); 
    dispatch(fetchWhatWeDoSuccess(response.results.data)); 
  } catch (error) {
    dispatch(fetchWhatWeDoFailure(error.message || "Failed to fetch what we do data."));
  }
};

export default whatWeDoSlice.reducer;
